export const TRACKED_TAG_ATTRIBUTES = ['sa-reason']
export const IGNORED_TAG_ATTRIBUTES = ['sa-tag-image', 'sa-tag-name']
